import React, { useState, useEffect, useRef } from "react";
import {
  converteCodigo,
  trataAtleta,
  trataInicio,
  separaBlocos,
} from "./utils";
import GravarBlocos from "./GravaBlocos";
import { getAdminShortcuts } from "../../services/api.js";

const Inputs = ({
  set,
  sacador,
  homeNumbers,
  visitorNumbers,
  lastScout,
  idPartida,
  firstScout,
  parametros,
  homeLeft,
  onScoutUpdate,
  placar,
  onRefresh,
  ultimoSet,
  getVideoTime,
}) => {
  const [codigos, setCodigos] = useState("");
  const [atletas, setAtletas] = useState([]);
  const [digitado, setDigitado] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [tempo, setTempo] = useState(0);
  const [shortcuts, setShortcuts] = useState([]); // Estado para armazenar os atalhos

  const [lista, setLista] = useState([]);
  const [saque, setSaque] = useState(sacador);
  const [setAtual, setSetAtual] = useState(false);

  const inputRef = useRef(null);
  const [shouldUpdateInput, setShouldUpdateInput] = useState(true);

  // Carregar atalhos uma vez quando o componente monta
  useEffect(() => {
    const loadShortcuts = async () => {
      try {
        const response = await getAdminShortcuts();
        setShortcuts(response.data);
      } catch (error) {
        console.error("Erro ao carregar atalhos:", error);
        // Se não conseguir carregar, continua sem atalhos
      }
    };
    loadShortcuts();
  }, []);

  // Função para substituir originalKey por mappedKey
  const replaceShortcuts = (text) => {
    let result = text;
    shortcuts.forEach((shortcut) => {
      // Substitui todas as ocorrências da originalKey pela mappedKey
      const regex = new RegExp(
        shortcut.originalKey.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
        "g"
      );
      result = result.replace(regex, shortcut.mappedKey);
    });
    return result;
  };

  useEffect(() => {
    if (shouldUpdateInput) {
      if (sacador === "*" && homeNumbers) {
        setDigitado(homeNumbers[0] + "S" || "");
      } else if (sacador === "a" && visitorNumbers) {
        setDigitado(sacador.toUpperCase() + visitorNumbers[0] + "S" || "");
      }
    }
  }, [sacador, homeNumbers, visitorNumbers, placar]);

  useEffect(() => {
    if (inputRef.current) {
      setTimeout(() => {
        inputRef.current.focus();
        const len = inputRef.current.value.length;
        inputRef.current.setSelectionRange(len, len);
      }, 0);
    }
  }, [digitado]);

  const handleCodes = (e) => {
    setShouldUpdateInput(false);
    const valorDigitado = e.target.value;

    // Aplica as substituições de atalhos
    let valorConvertido = replaceShortcuts(valorDigitado);

    setDigitado(valorConvertido.toUpperCase() || "");
    const novoCodigo = trataInicio(valorConvertido);
    setCodigos(novoCodigo);
    setAtletas([trataAtleta(novoCodigo)]);
  };

  const handleKeyDown = async (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      setIsLoading(true);
      setError(null);

      // Limpa o localStorage para garantir que só a última ação fique registrada
      localStorage.removeItem("lastBlocosIds");

      try {
        const blocos = digitado.trim().split(" ");
        const blocosComPontos = separaBlocos(blocos);
        setLista(blocosComPontos);

        const atletasProcessados = blocosComPontos.map((bloco) =>
          converteCodigo(bloco)
        );
        setAtletas(atletasProcessados);

        const tempoInic = getVideoTime ? getVideoTime() : 0;
        const tempo = tempoInic !== 0 ? tempoInic - 10 : 0;
        const blocosIds = await GravarBlocos(
          atletasProcessados,
          lastScout,
          idPartida,
          set,
          firstScout,
          parametros,
          homeLeft,
          tempo
        );
        // Armazena os IDs dos blocos gravados
        // localStorage.setItem("lastBlocosIds", JSON.stringify(blocosIds));

        // Limpa o input e notifica o componente pai para atualizar os dados
        setDigitado("");
        setLista([]);
        setAtletas([]);
        setShouldUpdateInput(true);
        if (onScoutUpdate) {
          onScoutUpdate();
        }
        if (onRefresh) {
          onRefresh();
        }
      } catch (error) {
        console.error("Erro ao gravar blocos:", error);
        setError("Erro ao gravar os dados. Tente novamente.");
      } finally {
        setIsLoading(false);
      }
    } else if ((e.ctrlKey || e.metaKey) && e.key === "z") {
      e.preventDefault();

      setLista((prevLista) => {
        const novaLista = [...prevLista];
        novaLista.pop();
        return novaLista;
      });

      setDigitado((prevDigitado) => {
        const blocos = prevDigitado.split(" ");
        blocos.pop();
        return blocos.join(" ");
      });
    } else {
      // const blocos = digitado.split(" ");
      // setLista(blocos);
      // const atletasProcessados = blocos.map((bloco) => converteCodigo(bloco));
      // setAtletas(atletasProcessados);
    }
  };

  return (
    <div>
      <input
        ref={inputRef}
        id="code"
        type="text"
        value={digitado}
        onChange={handleCodes}
        onKeyDown={handleKeyDown}
        className="border border-gray-400 px-4 py-2 w-full rounded-md mt-8"
        required
        disabled={isLoading || parseInt(set) !== parseInt(ultimoSet)}
      />
      {error && <div className="text-red-600 mt-2 text-sm">{error}</div>}
      {isLoading && (
        <div className="text-gray-600 mt-2 text-sm">Salvando...</div>
      )}
    </div>
  );
};

export default Inputs;
